import React from 'react'
import gql from 'graphql-tag'
import VIDEOS_QUERY from 'routes/videos.query'
import { Mutation } from 'react-apollo'

const ARCHIVE_USER_VIDEO = gql`
  mutation ArchiveUserVideo($input: ArchiveUserVideoInput!) {
    archiveUserVideo(input: $input) {
      archived
    }
  }
`

const ArchiveUserVideoMutation = ({ children, videoId }) => (
  <Mutation mutation={ARCHIVE_USER_VIDEO}>
    {(mutation, props) =>
      children({
        ...props,
        archiveUserVideo: () =>
          mutation({
            variables: {
              input: {
                video_id: videoId
              }
            },
            optimisticResponse: {
              archiveUserVideo: {
                __typename: 'ArchiveUserVideoPayload',
                archived: true
              }
            },
            update: (cache, { data }) => {
              try {
                const { viewer } = cache.readQuery({
                  query: VIDEOS_QUERY
                })

                cache.writeQuery({
                  query: VIDEOS_QUERY,
                  data: {
                    viewer: {
                      ...viewer,
                      videos: {
                        ...viewer.videos,
                        edges: viewer.videos.edges.map(
                          edge =>
                            edge.node.id === videoId
                              ? {
                                  ...edge,
                                  node: {
                                    ...edge.node,
                                    archived: data.archiveUserVideo.archived
                                  }
                                }
                              : edge
                        )
                      }
                    }
                  }
                })
              } catch (e) {
                // Error was thrown because we were on the show route without
                // going through the list page first, therefore the fragment
                // has not yet been loaded
                // https://github.com/apollographql/apollo-client/issues/1542
              }
            }
          })
      })
    }
  </Mutation>
)

export default ArchiveUserVideoMutation



// WEBPACK FOOTER //
// ./src/components/mutations/ArchiveUserVideo.js